import {homePage} from '@/config';
import {goBack, goCS, goTo} from '@/utils';
import {useLinkedTabs} from '@/utils/hooks';
import {useLogin} from '@/utils/state-hooks';
import {ReactComponent as ChavronLeft} from '@assets/icons/chavron-left.svg';
import {ReactComponent as Service} from '@assets/icons/service.svg';
import {Button, Tabs} from 'antd-mobile';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
interface NavTitleProps {
  onTabChange?: (tab: string) => void;
}

const NavTitle = ({onTabChange}: NavTitleProps) => {
  const {t} = useTranslation();

  const {tabKey, onTabChange: handleTabChange} = useLinkedTabs({
    routeParamKey: 'tabKey',
    tabsData: [{tabKey: 'bonus'}, {tabKey: 'promotion'}],
    onTabChange: tab => {
      onTabChange?.(tab);
    },
  });

  const login = useLogin();

  useEffect(() => {
    if (tabKey === 'bonus' && !login) {
      goTo('Login', {backPage: homePage, successPage: homePage});
    }
  }, [tabKey, login]);

  return (
    <div className="z-50 flex h-11 w-full flex-none flex-row items-center justify-between gap-3 bg-white px-3">
      <Button
        className="h-6 w-6 min-w-0 rounded-none bg-transparent p-0"
        onClick={goBack}>
        <ChavronLeft className="size-6 text-t2" />
      </Button>
      <Tabs
        className="base-tabs [&_.adm-tabs-tab-list]:gap-[3.75rem] [&_.adm-tabs-tab]:px-0 [&_.adm-tabs-tab]:text-base"
        activeLineMode="fixed"
        activeKey={tabKey}
        onChange={handleTabChange}>
        <Tabs.Tab title={t('promotionsV2.bonus')} key="bonus" />
        <Tabs.Tab title={t('promotionsV2.promotion')} key="promotion" />
      </Tabs>
      <Button
        className="h-auto min-w-0 rounded-none bg-transparent p-0"
        onClick={() => goCS()}>
        <Service className="size-6" />
      </Button>
    </div>
  );
};
export default NavTitle;
